import { withStyles } from '@material-ui/core/styles';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { OrderReviewContext } from '../../../../QaOrderReview/OrderReviewContext';
import ReactSelectWrapper from '../../../ReactSelectWrapper';
import {
  createSelectOptions,
  getAnswerImages,
  getOtherAnswer,
  multiSelectIsChecked,
  removeChildAnswers,
} from '../../FormDefinitionInput.utils';
import OtherTextField from '../OtherTextField';
import styles from './Select.styles';

const propTypes = {
  classes: PropTypes.object.isRequired,
  checkIfAnswerTriggersNewFormHeader: PropTypes.func.isRequired,
  formDefinition: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  imageToEdit: PropTypes.object,
  removeAnswers: PropTypes.func.isRequired,
  saveAnswers: PropTypes.func.isRequired,
  updateFormHeaders: PropTypes.func.isRequired,
};

const Select = ({
  classes,
  checkIfAnswerTriggersNewFormHeader,
  formDefinition,
  isReadOnly,
  imageToEdit,
  removeAnswers,
  saveAnswers,
  updateFormHeaders,
}) => {
  const { dispatch: orderReviewDispatch } = useContext(OrderReviewContext);
  const saveAnswersDebounceHandler = useCallback(
    debounce(newAnswers => {
      saveAnswers(newAnswers);
    }, 750),
    [],
  );

  const handleOnChange = async event => {
    const eventAnswerTrigger = formDefinition.answerTriggers.find(
      at => at.answerValueId.toString() === event.target?.value.toString(),
    );
    const eventAnswerValue = eventAnswerTrigger ? eventAnswerTrigger.answerValue : null;
    let newAnswers = [];
    let answerImages = getAnswerImages(formDefinition, imageToEdit);
    if (!formDefinition.answers.find(answer => answer.valueId === event.target.value)) {
      newAnswers = [
        {
          orderFormHeaderId: formDefinition.orderFormHeaderId,
          formDefinitionId: formDefinition.formDefinitionId,
          questionId: formDefinition.questionId,
          formQaAnswerId: formDefinition.answers.length !== 0 ? formDefinition.answers[0].formQaAnswerId : null,
          type: formDefinition.answerType,
          valueId: event.target.value,
          value: eventAnswerValue,
          text: null,
          modifiedOn: new Date(),
          images: answerImages,
          default: formDefinition.answers.length !== 0 ? formDefinition.answers[0].default : null,
        },
      ];
    }
    removeChildAnswers(formDefinition, event.target.value, false, orderReviewDispatch, removeAnswers);
    updateFormHeaders(newAnswers);
    if (newAnswers.length === 0) {
      removeAnswers(formDefinition.answers);
    } else {
      saveAnswersDebounceHandler(newAnswers);
    }
    checkIfAnswerTriggersNewFormHeader(event.target.value);
  };

  const otherAnswer = getOtherAnswer(formDefinition, imageToEdit);
  const selectOptions = createSelectOptions(formDefinition);

  return (
    <React.Fragment>
      <ReactSelectWrapper
        isClearable
        isDisabled={isReadOnly}
        options={selectOptions}
        value={selectOptions.filter(o =>
          multiSelectIsChecked(formDefinition, imageToEdit, o.value, formDefinition.formDefinitionId),
        )}
        onChange={handleOnChange}
      />
      {otherAnswer && (
        <OtherTextField
          formDefinition={formDefinition}
          isReadOnly={isReadOnly}
          imageToEdit={imageToEdit}
          otherAnswer={otherAnswer}
          removeAnswers={removeAnswers}
          saveAnswers={saveAnswers}
          updateFormHeaders={updateFormHeaders}
        />
      )}
    </React.Fragment>
  );
};

Select.propTypes = propTypes;
export default withStyles(styles)(Select);
